import React from "react";
import LandlordInfo from "./landlord-info";
import CompanyInfo from "./company-info";
import Approval from "./approval";
import Breadcrumbs from "../../reusebale/breadcrumbs"

const LandlordApproval = ({ onBack, selectedLandlord }) => {

  return (
    <div className="h-full">
      <div className="mt-5">

        <Breadcrumbs
          classes={`text-darkColor font-popinsSemiBold text-lg`}
          content={`LAND-${(selectedLandlord?._id)?.slice(0, 10)}`}
          subheading="LandLord Details"
          onBack={onBack}
        />
      </div>
      <div className="flex justify-between mt-4">
        <div className="w-[49%]">
          <LandlordInfo selectedLandlord={selectedLandlord} />
        </div>
        <div className="w-[49%]">
          <CompanyInfo selectedLandlord={selectedLandlord} />
        </div>
      </div>




      <div className="">
        <Approval selectedLandlord={selectedLandlord} onClose={onBack} />
      </div>
    </div>
  );
};

export default LandlordApproval;
